module.exports = __webpack_public_path__ + "Server-Unknown-Kubernetes.840eb1c8dc2802f1a7096b7c71f7754d.hashedasset.svg";